import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import {
  WithStyles,
  Typography,
  MenuItem,
  Grid,
  TextField,
  Checkbox,
  ListItemText,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import contentSubtypeActions from "../../mylibrary/actions/contentSubtypeActions";
import { ContentSubType } from "../../test-template/types/ContentSubTypeBody";
import { getContentSubType } from "../../test-template/actions/testTemplateActions";
import { bindActionCreators } from "redux";
import { MyPATSelect } from "../../common";

import { TestDetailStyle } from "../styles/TestDetailStyle";
import contentService from "../services/contentRequestServices";
import CourseData from "../../mylibrary/types/CourseData";
import classNames from "classnames";
import { fetchSubjects, addSubject } from "../actions/contentRequestActions";
import { contentRequestCreateActions } from '../reducers/contentRequestCreateReducer'
import { ContentRequest, Question, Subject } from "../types/ContentRequest";
import MyPATBaseSection from "../../common/MyPATBaseSection";


interface AddQuestionDetailProps extends WithStyles<typeof TestDetailStyle> {
  classes: any;
  fetchSubjects: Function;
  subjects: any[];
  contentsubType: ContentSubType[];

  contentSubtypeList: Function;
  addSubject: Function;
  removeSubject: Function;
  selectedSubjects: any[];
  transferToParent: (requestData: ContentRequest) => void;
  requestData: ContentRequest;
  isSectionDisabled?: boolean;
  setSelectedQuestionCodes: (questionCodes: string[]) => void;
}

interface AddQuestionDetailStates {
  courses: CourseData[];
  selectedCourseIds: any[];
  selectedQuestionCodes: string[];
}

class AddQuestionDetail extends Component<
  AddQuestionDetailProps,
  AddQuestionDetailStates
> {
  constructor(props: AddQuestionDetailProps) {
    super(props);

    this.state = {
      courses: [],
      selectedCourseIds: this.getInitialSelectedCourseIds(props.requestData),
      selectedQuestionCodes: [],
    };
    this.handleSubjectChange = this.handleSubjectChange.bind(this);
  }

  getInitialSelectedCourseIds = (requestData: ContentRequest) => {
    return _.get(requestData.requestInfo, "details.courseTypes", []).map(
      ({ id }: any) => id
    );
  };

  getInitialSelectedQuestionCodes = (requestData: ContentRequest) => {
    const subjects = _.get(requestData.requestInfo, "details.subjects", []);
    const questionCodesSet = subjects.reduce(
      (acc: Set<string>, subject: Subject) => {
        const questions = _.get(subject, "questions", []);
        questions.forEach(({ code }) => {
          acc.add(code.toString());
        });
        return acc;
      },
      new Set([])
    );
    const questionCodes: string[] = Array.from(questionCodesSet)
    return questionCodes;
  };

  componentDidMount() {
    _.isEmpty(this.props.contentsubType) && this.props.contentSubtypeList();
    const { selectedCourseIds } = this.state;
    const { requestData } = this.props;
    if (selectedCourseIds) {
      this.props.fetchSubjects(selectedCourseIds);
    }

    const initiallySelectedQuestionCodes = this.getInitialSelectedQuestionCodes(this.props.requestData);
    if(initiallySelectedQuestionCodes.length > 0) {
      this.props.setSelectedQuestionCodes(initiallySelectedQuestionCodes);
      this.setState({ selectedQuestionCodes: initiallySelectedQuestionCodes })
    }

    const initiallySelectedSubjectIds = requestData.requestInfo.details.subjects.map(
      ({ id }) => id
    );
    this.props.addSubject(initiallySelectedSubjectIds);

    contentService
      .goalList()
      .then((courses: CourseData[]) => this.setState({ courses }));
  }

  handleGoalChange(event: any) {
    this.props.fetchSubjects(event.target.value);
    this.setState({ selectedCourseIds: event.target.value }, () =>
      this.propagateGoalChange()
    );
  }
  handleQuestionChange(event: any) {
    const selectedQuestionCodes = event.target.value;
    this.props.setSelectedQuestionCodes(selectedQuestionCodes)
    this.setState(
      {
        selectedQuestionCodes,
      },
      () => this.propagateQuestionsChange()
    );
  }
  handleSubjectChange(event: any) {
    const values = event.target.value;
    let selectedSubjectIds = values;
    if (values.typeof == "string") {
      selectedSubjectIds = [values];
    }
    this.props.addSubject(selectedSubjectIds);
    this.propagateSubjectsChange(selectedSubjectIds);
  }

  propagateGoalChange = () => {
    const { selectedCourseIds, courses } = this.state;
    const { requestData, transferToParent } = this.props;
    const selectedCourses = courses.filter(({ _id }) =>
      selectedCourseIds.includes(_id)
    );
    if (selectedCourses.length > 0) {
      const newRequestData = { ...requestData };
      newRequestData.requestInfo.details.courseTypes = selectedCourses.map(
        ({ _id, name }) => ({ id: _id, name })
      );
      transferToParent(newRequestData);
    }
  };

  propagateQuestionsChange = () => {
    const { selectedSubjects: selectedSubjectIds } = this.props;
    // questions data is embedded in subjects
    // Thus, triggering propagateSubjectsChange to handle question code changes as well
    this.propagateSubjectsChange(selectedSubjectIds);
  };

  propagateSubjectsChange = (selectedSubjectIds: string[]) => {
    const { subjects, requestData, transferToParent } = this.props;
    
    const selectedSubjects = subjects.filter(({ _id }) =>
      selectedSubjectIds.includes(_id)
    );
    // Create a generic question data for all subjects
    // with just type and code
    const questionsData = this.createQuestionDataForSubject();
    const subjectData = selectedSubjects.map(({ name, _id }) => {
      const foundSubject=requestData.requestInfo.details.subjects.find((subject)=>{
        return subject.id===_id;
      });
      
      if(foundSubject){
        return foundSubject;
      }
      return {
        name,
        id: _id,
        questions: questionsData,
      };
    });
    const newRequestData = { ...requestData };
    newRequestData.requestInfo.details.subjects = subjectData;
    transferToParent(newRequestData);
  };

  createQuestionDataForSubject = (): Question[] => {
    const { selectedQuestionCodes } = this.state;
    const { contentsubType } = this.props;
    const selectedQuestions = contentsubType.filter(({ code }) =>
      selectedQuestionCodes.includes(code.toString())
    );
    return this.createQuestionDataFromSelectedQuestions(selectedQuestions);
  };

  createQuestionDataFromSelectedQuestions = (
    selectedQuestions: ContentSubType[]
  ) => {
    return selectedQuestions.map(({ code, name }) => {
      return {
        count: "",
        code,
        type: name,
        description: "",
        contentRequestItemsId: null,
        passage: [],
        authors: [],
        syllabus: {
          subjects: [],
          secondarySubjects: [],
        },
      };
    });
  };

  renderQuestion = () => {
    const { contentsubType } = this.props;
    const { selectedQuestionCodes } = this.state;

    return contentsubType
      .reduce((acc: string[], { code, name }) => {
        if (selectedQuestionCodes.includes(code.toString())) {
          acc.push(name);
        }
        return acc;
      }, [])
      .join(", ");
  };

  renderGoal = () => {
    const { courses, selectedCourseIds } = this.state;
    return courses
      .reduce((acc: string[], { _id, name }) => {
        if (selectedCourseIds.includes(_id)) {
          acc.push(name);
        }
        return acc;
      }, [])
      .join(", ");
  };
  renderer = () => {
    const { subjects, selectedSubjects } = this.props;
    return subjects
      .reduce((acc: string[], { _id, name }) => {
        if (selectedSubjects.includes(_id)) {
          acc.push(name);
        }
        return acc;
      }, [])
      .join(", ");
  };
  render() {
    const { classes, contentsubType, subjects, selectedSubjects, isSectionDisabled } = this.props;
    const { courses, selectedCourseIds, selectedQuestionCodes } = this.state;

    return (
      <MyPATBaseSection sectionId="questionDetails">
        <Grid className={classNames(classes.lightQuestionCard, isSectionDisabled && classes.disabledSection )}>
          <Grid container>
            <Grid item xs={12}>
            <Typography className={classes.mainHeading}>Question Details</Typography>
            </Grid>
          </Grid>
          <Grid container justify="flex-start" spacing={24}>
            <Grid item xs={4}>
              <div className={classes.customSelect}>
                <Typography className={classes.inputLabel}>
                  Question Type
                </Typography>

                <MyPATSelect
                  multiple={true}
                  isNative={false}
                  fullWidthControl
                  className={classNames(classes.margin)}
                  name="questionCodes"
                  value={selectedQuestionCodes}
                  onChange={this.handleQuestionChange.bind(this)}
                  customRenderFunc={this.renderQuestion}
                  displayEmpty
                  placeholder={
                    <Typography
                      variant="body2"
                      align="left"
                      inline
                      className={classes.greyText}
                    >
                      Select Question type
                    </Typography>
                  }
                  required
                >
                  {contentsubType.map(({ code, name }) => (
                    <MenuItem value={code} key={code}>
                      <Checkbox
                        color="primary"
                        checked={selectedQuestionCodes.includes(code.toString())}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </MyPATSelect>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.customSelect}>
                <Typography className={classes.inputLabel}>Goal</Typography>
                <MyPATSelect
                  multiple={true}
                  isNative={false}
                  fullWidthControl
                  required
                  className={classNames(classes.margin)}
                  value={selectedCourseIds}
                  onChange={this.handleGoalChange.bind(this)}
                  customRenderFunc={this.renderGoal}
                  name="goalLevel"
                  displayEmpty
                  placeholder={
                    <Typography
                      variant="body2"
                      align="left"
                      inline
                      className={classes.greyText}
                    >
                      Select Goal
                    </Typography>
                  }
                >
                  {courses.map(({ _id, name }) => (
                    <MenuItem value={_id} key={_id}>
                      <Checkbox
                        color="primary"
                        checked={selectedCourseIds.includes(_id)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </MyPATSelect>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.customSelect}>
                <Typography className={classes.inputLabel}>Subjects</Typography>
                <MyPATSelect
                  multiple={true}
                  isNative={false}
                  fullWidthControl
                  required
                  onChange={this.handleSubjectChange}
                  inputId="subject"
                  name="subjects"
                  value={selectedSubjects}
                  customRenderFunc={this.renderer}
                  displayEmpty
                  placeholder={
                    <Typography
                      variant="body2"
                      align="left"
                      inline
                      className={classes.greyText}
                    >
                      Select Subject
                    </Typography>
                  }
                >
                  {(subjects || []).map(({ _id, name }) => (
                    <MenuItem key={_id} value={_id}>
                      <Checkbox
                        color="primary"
                        checked={selectedSubjects.includes(_id)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </MyPATSelect>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </MyPATBaseSection>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    contentsubType: _.get(state, "testTemplate.contentSubType.list", {}),
    subjects: state.contentRequestReducer.contentRequestCreateReducer.subjects,
    selectedSubjects:
      state.contentRequestReducer.contentRequestCreateReducer.selectedSubjects,
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      contentSubtypeList: contentSubtypeActions.list,
      fetchSubjects,
      addSubject,
      setSelectedQuestionCodes: contentRequestCreateActions.setSelectedQuestionCodes
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(TestDetailStyle)(AddQuestionDetail));
